import { http } from './http'

const BASIC_AUTH = 'Basic YWRtaW46R2VubG9naW5AMTIzNTIx'

export async function getPeerSessions (params) {
  const q = params || {}
  const res = await http.get('/api/v1/sessions/peers', {
    params: {
      limit: q.limit,
      offset: q.offset,
      keyword: q.keyword || undefined,
      status: q.status || undefined,
      country: q.country || undefined,
      sort_by: q.sort_by || undefined
    },
    headers: { Authorization: BASIC_AUTH }
  })
  return res.data
}

export async function getExternalSessionsSummary () {
  const res = await http.get('/api/v1/sessions/external/summary', {
    headers: { Authorization: BASIC_AUTH }
  })
  return res.data
}

export async function getExternalSessions (params) {
  const q = params || {}
  const res = await http.get('/api/v1/sessions/external', {
    params: {
      limit: q.limit,
      offset: q.offset,
      status: q.status || undefined,
      keyword: q.keyword || undefined
    },
    headers: { Authorization: BASIC_AUTH }
  })
  return res.data
}




// WEBPACK FOOTER //
// ./src/api/sessions.js